const emitterProps = {
  cart: {
    get: 'cart.get',
    add: 'cart.add',
    update: 'cart.update',
    clear: 'cart.clear',
    count: 'cart.count',
    change: 'cart.change',
    render: 'cart.render'
  },
  product: {
    updateVariant: 'product.update_variant',
    openQuickAdd: 'product.open_quick_add',
    closeQuickAdd: 'product.close_quick_add',
    updateSwatches: 'product.update_swatches',
    openBISNotify: 'product.open_bis_notify'
  },
  notice: {
    global: 'notice.global'
  },
  subscription: {
    update: 'subscription.update',
    editProduct: 'subscription.edit_product'
  },
  account: {
    show: 'account.show'
  },
  slideout: {
    open: 'slideout.open',
    close: 'slideout.close'
  }
}

class GlobalEmitter {
  emit(name, payload) {
    const event = new CustomEvent(name, {
      detail: payload
    })

    document.dispatchEvent(event)
  }

  on(name, callback) {
    document.addEventListener(name, (e) => {
      callback(e.detail)
    })
  }

  off(name, callback) {
    document.removeEventListener(name, callback)
  }
}

const globalEmitter = new GlobalEmitter()

export { emitterProps, globalEmitter }
